module.exports = __webpack_public_path__ + "school/img/back3.6595ec74.jpg";